module.exports = __webpack_public_path__ + "static/media/logo.7734b9d1.jpg";